import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "../config";
import router from "../router/index";

Vue.use(Vuex);

const headerObj = accessToken => {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
};

export default new Vuex.Store({
  state: {
    userId: "",
    displayName: "",
    accessToken: "",
    liffState: "",
    numberOfPeople: 0,
    couponCode: "",
    lotteryResult: "",
    participantId: null
  },
  getters: {
    userId: state => {
      return state.userId;
    },
    displayName: state => {
      return state.displayName;
    },
    accessToken: state => {
      return state.accessToken;
    },
    liffState: state => {
      return state.liffState;
    },
    numberOfPeople: state => {
      return state.numberOfPeople;
    },
    couponCode: state => {
      return state.couponCode;
    },
    lotteryResult: state => {
      return state.lotteryResult;
    },
    participantId: state => {
      return state.participantId;
    }
  },
  mutations: {
    setUserId: (state, userId) => {
      state.userId = userId;
    },
    setDisplayName: (state, displayName) => {
      state.displayName = displayName;
    },
    setAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    setLiffState: (state, liffState) => {
      state.liffState = liffState;
    },
    setNumberOfPeople: (state, numberOfPeople) => {
      state.numberOfPeople = numberOfPeople;
    },
    setCouponCode: (state, couponCode) => {
      state.couponCode = couponCode;
    },
    setLotteryResult: (state, lotteryResult) => {
      state.lotteryResult = lotteryResult;
    },
    setParticipantId: (state, participantId) => {
      state.participantId = participantId;
    }
  },
  actions: {
    async initializeApp({ dispatch }) {
      await liff.init({ liffId: config.liffId }, async () => {
        if (liff.isLoggedIn()) {
          await dispatch("getLineUser");
          await dispatch("decideRoute");
        } else {
          liff.login();
        }
      });
    },
    async getLineUser({ dispatch, commit }) {
      await dispatch("getLiffState");
      const profile = await liff.getProfile();
      const accessToken = await liff.getAccessToken();
      commit("setUserId", profile.userId);
      commit("setDisplayName", profile.displayName);
      commit("setAccessToken", accessToken);
      await dispatch("getResult");
    },
    async getLiffState({ commit }) {
      try {
        const response = await axios.get(`${config.endpoint}/status`);
        commit("setLiffState", response.data.status);
      } catch (error) {
        console.log(error);
      }
    },
    async getResult({ state, commit }) {
      try {
        const response = await axios.get(
          `${config.endpoint}/registrations/${state.userId}`,
          headerObj(state.accessToken)
        );
        if (response.status === 200) {
          commit("setCouponCode", response.data.data.couponCode);
          commit("setLotteryResult", response.data.data.lotteryResult);
          commit("setNumberOfPeople", response.data.data.numberOfPeople);
          commit("setParticipantId", response.data.data.participantId);
        }
      } catch (error) {
        console.log("未登録のユーザーです", error);
      }
    },
    async postRegistration({ dispatch, state }, params) {
      try {
        const response = await axios.post(
          `${config.endpoint}/registrations`,
          params,
          headerObj(state.accessToken)
        );
        if (response.status === 200) {
          await dispatch("getResult");
          router.push({ name: "CompletedRegistration" });
        }
      } catch (error) {
        alert("すでにお申し込みを受け付けております。");
        router.push({ name: "CompletedRegistration" });
      }
    },
    decideRoute({ state }) {
      // 開催中で申込済み -> 受付完了画面
      if (state.liffState === "open" && state.couponCode) {
        router.push({ name: "CompletedRegistration" });
        // 開催中で申込していない-> 受付画面
      } else if (state.liffState === "open" && state.couponCode === "") {
        router.push({ name: "Registration" });
        // 応募締切-> 応募締切画面
      } else if (state.liffState === "closed") {
        router.push({ name: "ClosedRegistration" });
        // 結果発表で当選しなかった場合-> 応募締切画面
      } else if (
        state.liffState === "results" &&
        state.lotteryResult === "notyet"
      ) {
        router.push({ name: "ClosedRegistration" });
        // 結果発表で応募していない場合-> 応募締切画面
      } else if (state.liffState === "results" && state.couponCode === "") {
        router.push({ name: "ClosedRegistration" });
        // 結果発表で当選した場合-> 当選画面
      } else if (
        state.liffState === "results" &&
        state.lotteryResult === "win"
      ) {
        router.push({ name: "Result" });
        // イベント終了-> 開催終了画面
      } else if (state.liffState === "finish") {
        router.push({ name: "Closed" });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js